<template>
  <div class="card-modern">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h3 class="card-title-modern">Report SPK by Progress Status</h3>
        <!-- <small class="text-muted">
            Monitoring progress kontrak (Review FLI, Review Vendor/Customer, Complete, dll).
          </small> -->
      </div>
    </div>
  
    <div class="d-flex align-items-end justify-content-end gap-2 mb-3 flex-wrap">
      <!-- <button class="btn btn-sm bg-success-subtle border border-success-subtle text-success-emphasis"
        style="border-radius:8px" :disabled="exporting" @click="doExport">
        <span v-if="exporting"><span class="spinner-border spinner-border-sm me-1"></span>Mengunduh...</span>
        <span v-else><i class="bi bi-file-earmark-excel me-1"></i>Export Excel</span>
      </button> -->
  
      <div style="width:180px">
        <label class="form-label small text-muted mb-1">Cari</label>
        <input v-model="filters.search" class="form-control" style="border-radius:8px"
          @keyup.enter="fetchData(1)" />
      </div>
  
      <div style="width:200px">
        <label class="form-label small text-muted mb-1">Progress Status</label>
        <select v-model="filters.progress_status" class="form-select" style="border-radius:8px">
          <option value="">Semua Progress</option>
          <option v-for="p in progressList" :key="p.value" :value="p.value">
            {{ p.description }}
          </option>
        </select>
      </div>
  
      <!-- <div v-if="isAdmin" style="width:200px">
        <label class="form-label small text-muted mb-1">Departemen</label>
        <select v-model="filters.division_id" class="form-select" style="border-radius:8px">
          <option value="">Semua Departemen</option>
          <option v-for="d in divisions" :key="d.mst_division_id" :value="d.mst_division_id">
            {{ d.mst_division_name }}
          </option>
        </select>
      </div> -->
  
      <button class="button-modern" @click="fetchData(1)"><i class="bi bi-search me-1"></i>Cari</button>
      <button class="btn btn-sm bg-light border text-dark" style="border-radius:8px;height:38px"
        @click="resetFilter">Reset</button>
    </div>
  
    <div class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Perusahaan</th>
            <th>Nomor Dokumen</th>
            <th>Departemen</th>
            <th>Progress Status</th>
            <th>Status</th>
            <!-- <th>Periode</th>
              <th>Renewal</th> -->
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="9" class="text-center py-4">Memuat...</td>
          </tr>
          <tr v-else-if="!data.length">
            <td colspan="9" class="text-center py-4 text-muted">Tidak ada data</td>
          </tr>
          <tr v-for="(item, idx) in data" :key="item.document_id" v-else>
            <td>{{ rowNum(idx) }}</td>
            <td>{{ item.mst_corporate_name || '-' }}</td>
            <td class="fw-bold">{{ item.document_number || '-' }}</td>
            <td>{{ item.mst_division_name || '-' }}</td>
            <td>
              <span class="badge-modern badge-info">{{ item.progress_status_name || '-' }}</span>
            </td>
            <td>{{ item.status_name || '-' }}</td>
            <!-- <td>{{ formatDate(item.start_date) }} – {{ formatDate(item.end_date) }}</td>
              <td>{{ item.renewal_type_name || '-' }}</td> -->
            <td class="text-center">
              <button class="btn-icon-hover icon-primary" @click="openDetail(item)" title="Detail">
                <i class="bi bi-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">Total {{ pagination.total }} data</small>
      <div class="d-flex align-items-center gap-2">
        <select v-model.number="pagination.limit" class="form-select form-select-sm" style="width:70px"
          @change="fetchData(1)">
          <option v-for="o in [10,25,50,100]" :key="o" :value="o">{{ o }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{disabled: pagination.page<=1}">
              <button class="page-link" @click="fetchData(pagination.page-1)">‹</button>
            </li>
            <li class="page-item disabled"><span class="page-link">{{ pagination.page }} / {{ totalPages }}</span></li>
            <li class="page-item" :class="{disabled: pagination.page>=totalPages}">
              <button class="page-link" @click="fetchData(pagination.page+1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import reportService from '@/services/reportContractStatusService';
import divisionService from '@/services/divisionService';
import parameterController from '@/services/parameterService';
import { getUserLogin } from '@/utils/auth';

const router = useRouter();
const user = getUserLogin() || {};
const isAdmin = computed(
  () => Number(user.group_id) === 1 || (user.group_name || '').toLowerCase().includes('admin')
);

const data = ref([]);
const divisions = ref([]);
const progressList = ref([]);
const loading = ref(false);
// const exporting = ref(false);
const filters = reactive({ search: '', division_id: '', progress_status: '' });
const pagination = reactive({ page: 1, limit: 10, total: 0 });
const totalPages = computed(() => Math.max(1, Math.ceil(pagination.total / pagination.limit)));

const buildParams = (extra = {}) => {
  const p = { page: pagination.page, limit: pagination.limit, ...extra };
  if (filters.search) p.search = filters.search;
  if (filters.progress_status !== '') p.progress_status = filters.progress_status;
  if (isAdmin.value && filters.division_id !== '') p.division_id = filters.division_id;
  return p;
};

const fetchData = async (page = 1) => {
  if (page < 1) return;
  loading.value = true;
  pagination.page = page;
  try {
    const res = await reportService.getList(buildParams({ page }));
    data.value = res.data.data || [];
    pagination.total = res.data.pagination?.total || 0;
  } catch (e) {
    console.error(e);
    alert('Gagal memuat Report Kontrak by Status');
    data.value = [];
  } finally {
    loading.value = false;
  }
};

const loadMasters = async () => {
  try {
    const prog = await parameterController.getAll({ param_id: 2, limit: 0, is_active: 1 });
    progressList.value = prog.data || [];
  } catch { progressList.value = []; }
  if (isAdmin.value) {
    try {
      const res = await divisionService.getAll();
      divisions.value = res.data?.data || [];
    } catch { divisions.value = []; }
  }
};

const resetFilter = () => {
  filters.search = '';
  filters.division_id = '';
  filters.progress_status = '';
  fetchData(1);
};

// const doExport = async () => {
//   exporting.value = true;
//   try {
//     const res = await reportService.exportExcel(buildParams({ page: 1, limit: 0 }));
//     const url = URL.createObjectURL(new Blob([res.data]));
//     const a = document.createElement('a');
//     a.href = url; a.download = 'Report_Kontrak_Status.xlsx'; a.click();
//     URL.revokeObjectURL(url);
//   } catch { alert('Gagal export'); }
//   finally { exporting.value = false; }
// };

const rowNum = (i) => (pagination.page - 1) * pagination.limit + i + 1;
// const formatDate = (d) => d ? new Intl.DateTimeFormat('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(d)) : '-';
const openDetail = (item) =>
  router.push({
    name: 'detaildocument',
    params: { id: item.document_id },
    query: { from: router.currentRoute.value.fullPath },
  });

onMounted(async () => { await loadMasters(); await fetchData(1); });
</script>